import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    MenuItem,
    Select,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddProvider({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const [providerForm, setProviderForm] = useState({
        providerName: "",
        authStatus: "authStatus",
        region: "Region",
        models: "",
        costProfile: "",
        routing: "",
        riskLevel: "Level",
    });

    const handleChange = (field: string, value: any) => {
        setProviderForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Provider</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Provider Name */}
                            <div className="control_group w_50">
                                <label htmlFor="provider-name">Provider Name</label>
                                <TextField
                                    placeholder="e.g. OpenAI, Google"
                                    fullWidth
                                    hiddenLabel
                                    value={providerForm.providerName}
                                    onChange={(e) =>
                                        handleChange("providerName", e.target.value)
                                    }
                                    inputProps={{ id: "provider-name" }}
                                />
                            </div>

                            {/* Auth Status */}
                            <div className="control_group w_50">
                                <label htmlFor="auth-status">Auth Status</label>
                                <Select
                                    fullWidth
                                    value={providerForm.authStatus}
                                    onChange={(e) =>
                                        handleChange("authStatus", e.target.value)
                                    }
                                    inputProps={{ id: "auth-status" }}
                                >
                                    <MenuItem value="authStatus" disabled>Select Auth Status</MenuItem>
                                    <MenuItem value="Connected">Connected</MenuItem>
                                    <MenuItem value="Disconnected">Disconnected</MenuItem>
                                </Select>
                            </div>

                            {/* Region */}
                            <div className="control_group w_50">
                                <label htmlFor="provider-region">Region</label>
                                <Select
                                    fullWidth
                                    value={providerForm.region}
                                    onChange={(e) =>
                                        handleChange("region", e.target.value)
                                    }
                                    inputProps={{ id: "provider-region" }}
                                >
                                     <MenuItem value="Region" disabled>Select Region</MenuItem>
                                    <MenuItem value="Global">Global</MenuItem>
                                    <MenuItem value="US">US</MenuItem>
                                    <MenuItem value="EU">EU</MenuItem>
                                    <MenuItem value="APAC">APAC</MenuItem>
                                </Select>
                            </div>

                            {/* Risk Level */}
                            <div className="control_group w_50">
                                <label htmlFor="risk-level">Risk Level</label>
                                <Select
                                    fullWidth
                                    value={providerForm.riskLevel}
                                    onChange={(e) =>
                                        handleChange("riskLevel", e.target.value)
                                    }
                                    inputProps={{ id: "risk-level" }}
                                >
                                     <MenuItem value="Level" disabled>Select Risk Level</MenuItem>
                                    <MenuItem value="Low">Low</MenuItem>
                                    <MenuItem value="Medium">Medium</MenuItem>
                                    <MenuItem value="High">High</MenuItem>
                                </Select>
                            </div>

                            {/* Models Supported */}
                            <div className="control_group">
                                <label htmlFor="models-supported">Models Supported</label>
                                <TextField
                                    placeholder="e.g. GPT-4o, GPT-4 Turbo"
                                    fullWidth
                                    hiddenLabel
                                    value={providerForm.models}
                                    onChange={(e) =>
                                        handleChange("models", e.target.value)
                                    }
                                    inputProps={{ id: "models-supported" }}
                                />
                            </div>

                            {/* Cost Profile */}
                            <div className="control_group">
                                <label htmlFor="cost-profile">Cost Profile</label>
                                <TextField
                                    placeholder="e.g. 30% above Generate credit capacity"
                                    fullWidth
                                    hiddenLabel
                                    value={providerForm.costProfile}
                                    onChange={(e) =>
                                        handleChange("costProfile", e.target.value)
                                    }
                                    inputProps={{ id: "cost-profile" }}
                                />
                            </div>

                            {/* Routing */}
                            <div className="control_group w_50">
                                <label htmlFor="routing-percent">Routing (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="e.g. 60"
                                    fullWidth
                                    hiddenLabel
                                    value={providerForm.routing}
                                    onChange={(e) =>
                                        handleChange("routing", e.target.value)
                                    }
                                    inputProps={{ id: "routing-percent" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Add Provider
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}